export enum HireStatus {
    All = 'All',
    NotInvited = 'not_invited',
    Invited = 'invited',
    InProgress = 'in_progress',
    Hired = 'hired',
}

export enum ResponseType {
    Applied = 'applied',
    Invited = 'invited',
    Mutual = 'mutual',
    Archive = 'archive',
}

export enum DatePeriod {
    AllTime,
    Today,
    Yesterday,
    Last7Days,
    Last30Days,
    CustomPeriod,
}
